import { render, staticRenderFns } from "./packageTypeComp.vue?vue&type=template&id=547310ee&scoped=true"
import script from "./packageTypeComp.vue?vue&type=script&lang=js"
export * from "./packageTypeComp.vue?vue&type=script&lang=js"
import style0 from "./packageTypeComp.vue?vue&type=style&index=0&id=547310ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547310ee",
  null
  
)

export default component.exports